import { render, staticRenderFns } from "./CategoryFiltersDesk.vue?vue&type=template&id=4ca0d366&"
import script from "./CategoryFiltersDesk.vue?vue&type=script&lang=js&"
export * from "./CategoryFiltersDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports